import { useEffect, useMemo, useState } from 'react';
import { OtherApi } from '../../../network';
import './style.scss';

const useAudio = (audio: HTMLAudioElement) => {
    const [playing, setPlaying] = useState(false);

    const toggle = () => setPlaying(!playing);

    useEffect(() => {
        playing ? audio.play() : audio.pause();
    }, [playing]);

    useEffect(() => {
        audio.addEventListener('ended', () => setPlaying(false));
        return () => {
            audio.removeEventListener('ended', () => setPlaying(false));
        };
    }, []);

    return { toggle, playing };
};

function LiveRadio() {
    const audio = useMemo(() => new Audio('https://broad-snow-f5c8.radim-radio.workers.dev'), []);
    const { toggle, playing } = useAudio(audio);
    const [nowPlaying, setCurrentlyPlaying] = useState({
        author: '',
        title: '',
    });

    // useEffect(() => {
    //     const getSong = () => {
    //         OtherApi.nowPlayingNowPlayingGet()
    //             .then((res) => {
    //                 const data = res.message.split(' - ');
    //                 setCurrentlyPlaying({
    //                     title: data[0].trim(),
    //                     author: data[1].trim(),
    //                 });
    //             })
    //             .catch((e) => console.error(e));
    //     };
    //     getSong();
    //     const interval = setInterval(getSong, 5000);
    //     return () => {
    //         clearInterval(interval);
    //     };
    // }, []);

    return (
        <div className="LiveRadio">
            <div className="track-data">
                <div className="title">{nowPlaying.title}</div>
                <div className="artist">{nowPlaying.author}</div>
            </div>
            <img
                src={playing ? `/srtop.svg` : `/play_header.svg`}
                className="play-image"
                onClick={toggle}
            />
        </div>
    );
}

export default LiveRadio;
